module.exports = __webpack_public_path__ + "img/JP-blank.55360c46.png";